import { Button, Div, FormBuilder, Label } from "@grassrootly/rn-core";
import { Platform } from "react-native";
import { PlayerCreateGroupProps } from "./PlayerCreateGroup.types";
import { useSafeAreaInsets } from "react-native-safe-area-context";

export function PlayerCreateGroup({ createGroupForm, onSubmit }: PlayerCreateGroupProps) {
  const insets = useSafeAreaInsets();
  
  return (
    <Div
      classNames={[
        "flex1",
        "bgNeutralDarkerDark",
        "p16",
        `pb-{${insets.bottom + 16 + (Platform.OS == "web" ? 16 : 0)}}`,
        "h100",
      ]}
    >
      <Div classNames={["flex1", "maxW-{920}", "w-{100%}", "mr-{auto}", "ml-{auto}"]}>
        <Div classNames={["flex1", "alignItemsCenter", Platform.OS === "web" ? "mt-{56}" : "justifyContentCenter"]}>
          <Label type="l2Regular" classNames={["mb-{24}", "mt-{16}"]}>
            Create a team name and go to victory
          </Label>
          <Div classNames={["w-{100%}", "maxW-{300}"]}>
            <FormBuilder
              form={createGroupForm}
              onSubmit={onSubmit}
              submitFormOnEnter={true}
              resetFormOnSubmit
              submitControl={(submit) => (
                <Button
                  title="Create Team"
                  onPress={submit}
                  classNames={["btn", "btnBlock", "btnPrimary", "mt-{8}"]}
                />
              )}
            />
          </Div>
        </Div>
      </Div>
    </Div>
  );
}
